// extracted by mini-css-extract-plugin
export default {"resetButton":"eC9WzKF","mark":"wvsGpIK"};